import { getPosts } from "./_get-posts";
const block = document.querySelector('section.press-releases');

if(block) {
  const showMoreBtn = block.querySelector('.show-more-btn');
  const container = block.querySelector('.releases');
  let offset = 7;
  if(showMoreBtn) {
    showMoreBtn.addEventListener('click', function(e) {
      e.preventDefault();
      getPosts(container, showMoreBtn, offset);
      offset += 6;
    });
  }
}

